export function valueIsNullOrEmpty(value: any) {
    return value == null || value == undefined || value === '';
}
